










import { Component, Vue } from 'vue-property-decorator';

import { isRemoteLoading } from '@/utils/remote-loading';

@Component<ConfirmPopup>({
  watch: {
    $route() {
      if (this.isVisible) {
        this.toggle();
      }
    }
  }
})
export default class ConfirmPopup extends Vue {
  isVisible = false;

  top: number = 0;
  left: number = 0;

  get isRemoteLoading() {
    return isRemoteLoading();
  }

  get modalStyle() {
    if (!this.isRemoteLoading) return {};

    return {
      position: 'absolute',
      left: 'calc(50% - 160px)',
      top: `${this.top}px`,
      transform: 'translateX(-50%)',
      marginLeft: `${this.left}px`
    };
  }

  toggle() {
    this.isVisible = !this.isVisible;
  }

  updateModalPosition() {
    try {
      const modal = this.$refs.modal as HTMLElement;
      if (!modal) return;

      // Reading the parent window cross-origin throws a SecurityError; fall
      // back to the iframe's own same-origin viewport so the modal stays
      // centered within the visible iframe area.
      let parentScrollY = 0;
      let viewportHeight = window.innerHeight;
      try {
        const scrollElement = window.parent.document.getElementById(
          'main-content'
        );
        parentScrollY = scrollElement ? scrollElement.scrollTop : 0;
        viewportHeight = window.parent.innerHeight;
      } catch (crossOriginErr) {
        parentScrollY = 0;
        viewportHeight = window.innerHeight;
      }

      const modalHeight = modal.offsetHeight || 0;

      let iframeRects = { top: 0 };
      try {
        if (window.frameElement) {
          iframeRects = window.frameElement.getBoundingClientRect();
        }
      } catch (crossOriginErr) {
        iframeRects = { top: 0 };
      }
      const iframeOffsetTop = iframeRects.top || 0;

      const top =
        parentScrollY -
        (parentScrollY + iframeOffsetTop) +
        (viewportHeight / 2 - modalHeight / 2);

      this.top = Math.max(top, 0);
    } catch (err) {
      console.error('[CenteredModal] Failed to update position:', err);
    }
  }

  messageUpdateModalPosition(event: MessageEvent) {
    if (event.data.type === 'updateModalPosition') {
      this.updateModalPosition();
    }
  }

  mounted() {
    this.updateModalPosition();

    window.addEventListener('resize', this.updateModalPosition);
    window.addEventListener('message', this.messageUpdateModalPosition);
  }

  beforeDestroy() {
    window.removeEventListener('message', this.messageUpdateModalPosition);
    window.removeEventListener('resize', this.updateModalPosition);
  }
}
